export const SharedMsgHelper = {
    getInvalidPasswordErrMsg:
        'Minimum 8 characters, at least one letter, one number and one special character: (@$!%*#?&^()-_+)',
    getInvalidEmailErrMsg: 'Email must be valid',
    getMissingRequiredErrMsg: 'Required!!',
    getNotAllowWhitespaceErrMsg: 'Not allow whitespace',
    getNotAlphanumericErrMsg: 'Alphanumeric Only',
    getInvalidAmountErrMsg: 'Number only',
    getInvalidIntegerErrMsg: 'Integer only',
    getInvalidDateErrMsg: 'YYYY-MM-DD only',
    getInvalidCourierCodeErrMsg: 'Invalid service',
    getInvalidcheckpointTimeUtcFormatErrMsg: 'Invalid Checkpoint time format! Must be UTC ISO 8601 format',
    getImportDoneMsg: 'Import process completed! Please check the result'
};
